import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { SummaryInformationCard } from 'app/components/summary-information-card';
import { i18n } from 'app/i18n';
import { selectSelectedAmountOfUnitsToPurchase, selectShoppingCartOrThrow } from 'app/pages/order/redux/order-selector';
import { CurrencyUtils } from 'app/utils/currency-utils';
import { ShoppingCartUtils } from 'app/utils/shopping-cart-utils';
import { HomeGatewayUpgrade } from 'app/pages/order/summary/product-information/home-gateway-upgrade';
import { wifiMeshUnitImageProps } from 'app/resources/images';
import { I18nUtils } from 'app/utils/i18n-utils';

import { ProductInformation } from './product-information';

export const ProductInformationCard: FunctionComponent = () => {
    const shoppingCart = useSelector(selectShoppingCartOrThrow);
    const { freeUnit, homeGatewayUpgrade, isUpgradeUnitAdded, establishmentCharge } = shoppingCart;
    const isIncludedOrUpgradeUnitAdded = freeUnit || isUpgradeUnitAdded;
    const numberOfWifiUnits = useSelector(selectSelectedAmountOfUnitsToPurchase);
    const selectedWifiOption = ShoppingCartUtils.getSelectedWifiOption(shoppingCart, numberOfWifiUnits);

    return (
        <SummaryInformationCard
            title={i18n.page.summary.productInformation.title}
            content={
                <div>
                    <ProductInformation
                        productName={i18n.page.summary.productInformation.productName}
                        image={wifiMeshUnitImageProps}
                        amount={numberOfWifiUnits}
                        price={CurrencyUtils.formatPriceWithMonthlySuffix(selectedWifiOption.recurringCharge.price)}
                        amountText={i18n.page.summary.productInformation.quantityWifiUnit}
                        establishmentPrice={
                            establishmentCharge
                                ? I18nUtils.message(i18n.page.summary.productInformation.establishmentPrice, {
                                      price: CurrencyUtils.toFormattedShortPrice(establishmentCharge.price),
                                  })
                                : undefined
                        }
                    />
                    {isIncludedOrUpgradeUnitAdded && (
                        <ProductInformation
                            productName={i18n.page.summary.productInformation.productName}
                            image={wifiMeshUnitImageProps}
                            amount={1}
                            price={CurrencyUtils.formatPriceWithMonthlySuffix(0)}
                            amountText={i18n.page.summary.productInformation.quantityFreeUnit}
                        />
                    )}
                    {homeGatewayUpgrade && <HomeGatewayUpgrade homeGatewayUpgrade={homeGatewayUpgrade} />}
                </div>
            }
            totalPrices={[
                {
                    label: i18n.page.summary.productInformation.monthlyPrice,
                    value: CurrencyUtils.formatPriceWithSuffix(selectedWifiOption.recurringCharge.price),
                },
                {
                    label: i18n.page.summary.productInformation.nextBillPrice,
                    value: CurrencyUtils.formatPriceWithSuffix(selectedWifiOption.totalNextBillPrice),
                },
                {
                    label: i18n.page.summary.productInformation.firstYearPrice,
                    value: CurrencyUtils.formatPriceWithSuffix(selectedWifiOption.totalFirstYearPrice),
                },
            ]}
        />
    );
};
